<template>
    <ion-accordion value="new" class="bg-transparent" style="overflow: visible;">
        <ion-grid
            slot="header"
            class="timer-entry card-border coral-coral-color fw-b cursor-pointer max-height ion-no-padding light-medium-shadow"
            :class="gridColor"
        >
            <ion-row class="max-height px-3">
                <ion-col class="center-y" size="auto">
                    <div
                        class="round grey4-grey4-background coral-coral-color my-1"
                        style="height: 3rem; width: 3rem;"
                    >
                        <ion-icon :icon="addOutline" class="max-size"/>
                    </div>
                </ion-col>

                <ion-col class="ion-text-center center" style="padding-left: 5px">
                    {{ $t('label.newReminder') }}
                </ion-col>

                <ion-col class="center-y" size="auto">
                    <div
                        style="width: 3rem;"
                    >
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>

        <ion-grid slot="content" class="bg-transparent py-2">
            <timer-settings
                :css-class="cssClass"
                :timer="timer"
                @save="$emit('save', $event)"
                :settings="settings"
            />
        </ion-grid>
    </ion-accordion>
</template>

<script setup lang="ts">
import { IonAccordion, IonCol, IonGrid, IonIcon, IonRow } from "@ionic/vue";

import TimerSettings from "@/components/TimerSettings.vue";

import { Reminder } from "@/types/supplier";
import { AddOrderTimerProps } from "@/types/props";

import { addOutline } from "ionicons/icons";

withDefaults(defineProps<AddOrderTimerProps>(), {
    gridColor: 'grey4-grey4-background'
})
defineEmits<{ (e: 'save', value: Reminder): void }>()
</script>

<style scoped>
.timer-entry {
    height: 77px;
}
</style>
